export default __webpack_public_path__ + "static/media/KOD0047-min.f77285db.webp";